<template>
  <b-modal
    ref="modal"
    id="order-note-modal"
    hide-header
    hide-footer
    centered
    @hide="onHide"
    @show="onShow"
  >
    <div class="right">
      <div class="icon">
        <center>
          <font-awesome-icon @click="onHide" :icon="faTimes" />
        </center>
      </div>
    </div>

    <div class="notes-wrapper" ref="notesBox" v-if="orderNotes.length > 0">
      <div class="notes">
        <p :key="noteOrder.id" v-for="noteOrder in orderNotes">
          <span>{{ moment(noteOrder.createdAt, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]').format('DD/MM/YYYY HH:mm') }}</span>
          <span> - </span>
          <span>{{ noteOrder.createdBy.firstName }} {{ noteOrder.createdBy.lastName }}</span>
          <span>: </span>
          <span>{{ noteOrder.content }}</span>
        </p>
      </div>
    </div>
    <div class="notes-input">
      <text-input
        :label="$t('NOTES')"
        placeholder=" "
        borderbottom
        icon-position="right"
        v-model="orderNote"
        @keydown.enter="(e) => addNotes(e)"
        ref="noteOrderInput"
      >
        <template v-slot:icon>
          <font-awesome-icon class="icon right" :icon="faPaperPlane" @click="addNotes"/>
        </template>
      </text-input>
    </div>

  </b-modal>
</template>

<script>
import { watch, ref } from '@vue/composition-api';
import moment from 'moment';
import { createNamespacedHelpers } from 'vuex-composition-helpers';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faPaperPlane, faTimes } from '@fortawesome/free-solid-svg-icons';

import TextInput from '@/components/TextInput';

import OrderManagementService from '../OrderManagementService';

const { useGetters: useModalGetters, useActions: useModalActions } = createNamespacedHelpers('modal');

export default {
  name: 'OrderNoteModal',
  components: {
    TextInput,
    FontAwesomeIcon,
  },
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const { isOrderNoteModalActive: isOpen } = useModalGetters(['isOrderNoteModalActive']);
    const { toggleOrderNoteModal: toggleOrderNote } = useModalActions(['toggleOrderNoteModal']);

    const modal = ref(null);
    const orderNote = ref('');
    const orderNoteInput = ref(null);
    const orderNotes = ref([]);
    const notesBox = ref(null);

    const onHide = () => {
      toggleOrderNote(false);
    };

    const fetchNotes = async () => {
      if (!props.id) return;

      orderNotes.value = await OrderManagementService.getOrderNotes(props.id);
    };

    const onShow = () => {
      fetchNotes();
    };

    const addNotes = async (e) => {
      e.preventDefault();

      if (!props.id) return;

      if (!orderNote.value) return;

      await OrderManagementService.addOrderNotes(props.id, orderNote.value);
      await fetchNotes();
      orderNote.value = '';
    };

    watch(isOpen, (newVal) => {
      if (newVal) modal.value.show();
      else modal.value.hide();
    });

    return {
      moment,
      faPaperPlane,
      faTimes,
      orderNote,
      orderNoteInput,
      orderNotes,
      notesBox,
      onHide,
      onShow,
      addNotes,
      modal
    };
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/colors";

#order-note-modal {
  .right {
    display: flex;
    justify-content: flex-end;

    .icon {
      cursor: pointer;
      color: $geranium;
      font-size: 20px;
      transition: all .2s ease-in-out;

      &:hover {
        transform: scale(1.2);
      }
    }
  }

  .notes-wrapper {
    font-size: 13px;
    position: relative;
    height: 150px;
    border: 1px solid $alto;
    overflow-y: scroll;
    padding: 5px 10px;

    .notes {
      margin-top: 2px;
      font-size: 13px;
      height: 100%;
      p {
        margin: 0;
        span {
          color: $lavenderGrey;

          &:last-child {
            color: $independence;
          }
        }
      }
    }
  }

  .notes-input {
    margin-top: 17px;
    .text-input {
      .icon {
        transition: all .2s ease-in-out;
        cursor: pointer;

        &:hover {
          color: $paradisePink
        }
      }
    }
  }
}
</style>
